/*
* Return shorthand string representing field name
* @param {Object} ref
* @return {string}
*/
export default function (ref) {
  if (!ref || (!ref.$el && ref instanceof Element)) return ref.tagName.toLowerCase()
  const elementClassList = ref.$el.className
  if (elementClassList.includes('el-autocomplete')) {
    return 'autocomplete'
  } else if (elementClassList.includes('el-select')) {
    return 'select'
  } else if (elementClassList.includes('el-checkbox')) {
    return 'checkbox'
  } else if (elementClassList.includes('el-input') && !elementClassList.includes('el-date-editor')) {   // <el-date-editor> contains both el-input and el-date-editor classes
    return 'input'
  } else if (elementClassList.includes('el-date-editor')) {
    return 'date'
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/GetFieldType.js